<template>
  <flickity class="u-marg-t-lg" ref="flickity" :options="flickityOptions">
    <div
      class="carousel-cell u-w9of12 u-pad-x-sm"
      v-for="i in 7"
      :key="i"
    >
      <div class="themes__mobile__item u-pad-md u-bg-white u-black u-center">
        <div class="u-row u-center">
          <div class="u-w5of12">
            <div class="themes__mobile__item__image u-box-1by1">
              <div class="u-wrapper-panel">
                <img class="u-fit-cover" :src="`/images/theme-${i}.jpg`">
              </div>
            </div>
          </div>
        </div>
        <div class="themes__mobile__title t-h2 t-bold u-uppercase u-marg-b-sm">{{ $t('themes.title' + i) }}</div>
        <div class="t-text--big">{{ $t('themes.content' + i) }}</div>
      </div>
    </div>
  </flickity>
</template>

<script>
import Flickity from 'vue-flickity'

export default {
  components: {
    Flickity
  },

  data() {
    return {
      flickityOptions: {
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false 
      }
    }
  }
}
</script>

<style lang="stylus" scroped>
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

.carousel-cell
  padding-top 15%

.themes
  &__mobile
    &__item
      border-radius 20px
      padding-top 0
      
      &__image
        border-radius 50%
        overflow hidden
        transform translateY(-50%)

    &__title
      transform translateY(-1em)      
</style>